

const dataFrench = {
        nom:"FANE",
        prenom:"KONDJIRI",
        age:"04/01/1997",
        img:"/images/photo_identite.jpg",
        lieunaissance:"Mali-koulikoro-Sokindiarababougou",
        contact:{
            email:"kondjirif@gmail.com",
            github:"https://github.com/kondjiri",
            instagram:"https://www.instagram.com/kfane___/",
            youtube:"https://www.youtube.com/channel/UCRb3xbVq0f1Soa6TNIqCOcQ",
            facebook:"https://facebook.com/fanekondjiri",
            twitter:"https://twitter.com/FKondjiri",
            linkedin:"https://www.linkedin.com/in/fane-kondjiri-16521b19a/",
            location:"Mali-Bamako"
        },
        competence:
            [
                {text:"Python",percentage:"60%"},
                {text:"R",percentage:"5%"},
                {text:"PHP",percentage:"70%"},
                {text:"C",percentage:"70%"},
                {text:"Javascript",percentage:"88%"},
                {text:"Keras",percentage:"80%"},
                {text:"Tensorflow",percentage:"45%"},
                {text:"Java",percentage:"87%"},
                {text:"HTML & CSS",percentage:"90%"},
                {text:"AFTER EFFECT",percentage:"50%"},
                {text:"REACT JS",percentage:"85%"},
                {text:"OpenCV",percentage:"53%"},
                {text:"ADOOBE PREMIERE PRO",percentage:"80%"},
                {text:"PHOTOSHOP",percentage:"80%"}
            ],
            description:"Si vous avez des questions, suggestions ou bien vous voulez etre en contact avec moi pour (Offre d'emploi,job,travail,aide), Voici mon contact mail, vous pouvez m'ecrire et je ferai mon possible de vous repondre dans les plus brefs delai !",
            projectContent:"Voici  mes quelsques acticles ci-dessous, que vous pouvez lire leur intregralite sur mon Github, dont je suis le plus actif la-bas, vous pouvez aussi suivre mes actualites sur mes reseaux sociaux ci-dessous  !",
        projets:[
            {
                titre:"Classification des Images Multispectrales utilisant les Deep Learning",
                link:"2019-2020"
            },
            {
                titre:"La virtualisation Informatique",
                link:"2017-2018"
            },
            {
                titre:"Prepare a Topic around Busness management and Marketing | French",
                link:"2019"
            },
            {
                titre:"Proposer un modele et une amelioration pour la  Detection des Intruisions dans les Reseaux",
                link:"2019-2020"
             },
    
            ],
        certificat:[
            "International Summer School | English | Oran",
            "Metro Languages | English | Oran",
            "Javascript & Data Structure | FreeCodeCamp-Online",
            "InternShip Certificate | CTS-ARZEW-Oran",
            "InternShip Certificate | HASNAOUI-Oran",
            "FullStack Web Development | Be Smart Center-Oran",
            "Honor Certificate | INTTIC | Oran"
        ],
        centreInteret:[
            "Sport",
            "Lecture",
            "Travail d'Equipe",
            "Voyage"
        ],
        langues:[
            {langue:"Francais",niveau:"Maternelle"},
            {langue:"Anglais",niveau:"Professionnel"},
            {langue:"Bambara",niveau:"Maternelle"}
        ],
        associations:[
            "NOVEM | Mali",
            "Horizon Club | INTTIC",
            "Ignergy | INTTIC",
            "AESMA | Algrie-Oran",
            "LIEEMA | Algrie-Oran"
        ],
        profile:"Je suis récemment diplômé de l'Institut National des Télécommunications et des Technologies de l'Information et de la Communication (INTTIC) avec mon diplôme d'Ingénieur Informatique, Réseaux et Télécoms, je cherche toujours à élargir et développer mes compétences et mes connaissances",
        formations:[
            {
                date:"2015-2020",
                titre:"Ingenieur d'Etat en Telecommunication",
                lieu:"Institut National des Telecommunications et des TICs (INTTIC)"
            },
            {
                date:"2014-2014",
                titre:"Diplome de Baccalaureat",
                lieu:"Lycee BAminata Coulibaly (LBAC)"
            }
            
        ],
        experinces:[
            {
                date:"07/2019-08/2019",
                titre:"Stage HTA | Introduction en Reseaux et Informatique | Oran-Algerie",
                description:"-Network Administration, network automation, cloud storage, Data cCompression, Image and Signal Preprocessing and New Generation Network."
            },
            {
                date:"02/2020-09/2020",
                titre:"Stage CTS | Interprettion et Analyse des  Images Satellitaires par Machiine Learning et Deep Learning | Oran-Algerie",
                description:"-Build a Deep learning Model for Multispectral and Hyperspectral Images Scene Classification and Segmentation in Satellite Imagery and Propose methods to increase the performance."
            }
        ]
}


const dataAnglais = {
    nom:"FANE",
    prenom:"KONDJIRI",
    age:"04/01/1997",
    img:"/images/photo_identite.jpg",
    lieunaissance:"Mali-koulikoro-Sokindiarababougou",
    contact:{
        email:"kondjirif@gmail.com",
        github:"https://github.com/kondjiri",
        instagram:"https://www.instagram.com/kfane___/",
        youtube:"https://www.youtube.com/channel/UCRb3xbVq0f1Soa6TNIqCOcQ",
        facebook:"https://facebook.com/fanekondjiri",
        twitter:"https://twitter.com/FKondjiri",
        linkedin:"https://www.linkedin.com/in/fane-kondjiri-16521b19a/",
        location:"Mali-Bamako"
    },
    competence:
        [
            {text:"Python",percentage:"60%"},
            {text:"R",percentage:"5%"},
            {text:"PHP",percentage:"70%"},
            {text:"C",percentage:"70%"},
            {text:"Javascript",percentage:"88%"},
            {text:"Keras",percentage:"80%"},
            {text:"Tensorflow",percentage:"45%"},
            {text:"Java",percentage:"87%"},
            {text:"HTML & CSS",percentage:"90%"},
            {text:"AFTER EFFECT",percentage:"50%"},
            {text:"REACT JS",percentage:"85%"},
            {text:"OpenCV",percentage:"53%"},
            {text:"ADOOBE PREMIERE PRO",percentage:"80%"},
            {text:"PHOTOSHOP",percentage:"80%"}
        ],
    description:"If you have any questions, suggestions or you want  to get in touch with me for anything(job,work,help,ect...),Here is my contact mail, you can write me  and i'll make sure to respond to you as soon as possible  !",
    projectContent:"Here are some of my  works/articles below, that you can read them all on my Github, i spend most of my time over there and also you can follow me on my other social media below ! Hope you enjoy them",
    projets:[
        {
        titre:"Multispectral Image Scene classification using Deep Learning",
        link:"2019-2020"
        },
        {
            titre:"Computer Science Virtualisation",
            link:"2019-2020"
        },
        {
            titre:"Prepare a Topic around Busness management and Marketing",
            link:"2018-2019"
        },
        {
            titre:"Propose a model and Enhancement for Intruision Detection in a Networking Area",
            link:"2019-2020"
         },

        ],
    certificat:[
        "International Summer School | English | Oran",
        "Metro Languages | English | Oran",
        "Javascript & Data Structure | FreeCodeCamp-Online",
        "InternShip Certificate | CTS-ARZEW-Oran",
        "InternShip Certificate | HASNAOUI-Oran",
        "FullStack Web Development | Be Smart Center-Oran",
        "Honor Certificate | INTTIC | Oran"
    ],
    centreInteret:[
        "Sport",
        "Reading",
        "TeamWork",
        "Travelling"
    ],
    langues:[
        {langue:"French",niveau:"Mother Tongue"},
        {langue:"English",niveau:"Fluently"},
        {langue:"Bambara",niveau:"Mother Tongue"}
    ],
    associations:[
        "NOVEM | Mali",
        "Horizon Club | INTTIC",
        "Igenergy | INTTIC",
        "AESMA | Algrie-Oran",
        "LIEEMA | Algrie-Oran"
    ],
    profile:"I am a recent graduate from Institut National des Télécommunications et des Technologies de l'Information et de la Communication (INTTIC) with my Computer Science,Networking and Telecom Engineer Degree.I am always looking to expand and develop my skill-set and knowledge.",
    formations:[
        {
            date:"2015-2020",
            titre:"Telecom Engineer Degree",
            lieu:"Institut National des Telecommunications et des TICs (INTTIC)"
        },
        {
            date:"2014-2014",
            titre:"Baccalaureat Degree",
            lieu:"Lycee BAminata Coulibaly (LBAC)"
        }
        
    ],
    experinces:[
        {
            date:"07/2019-08/2019",
            titre:"Intership HTA | Introduction to Networking and Computer Science | Oran-Algeria",
            description:"-Network Administration, network automation, cloud storage, Data cCompression, Image and Signal Preprocessing and New Generation Network."
        },
        {
            date:"02/2020-09/2020",
            titre:"Intership CTS | Interprettion et Analysis of Satellites Images using Machiine Learning and Deep Learning | Oran-Algeria",
            description:"-Build a Deep learning Model for Multispectral and Hyperspectral Images Scene Classification and Segmentation in Satellite Imagery and Propose methods to increase the performance."
        }
    ]
}



export {dataAnglais,dataFrench};